import React from "react";
import {LngLat} from "maplibre-gl";
import {getModelFactory} from "../../../ts/model-factory/ModelFactory";
import {IRouteProps} from "../../../ts/manager/view/ViewInterface";
import {LocatableDataChoice} from "../../../ts/data/locate/LocatableDataFactory";
import RouteChoiceButton from "../../element/button/RouteChoiceButton";
import LocateMapPage from "../locate/LocateMapPage";
import {PostType} from "../../../ts/manager/post/PostManager";
import {getManager} from "../../../ts/manager/Manager";
import {PostDataChoice} from "../../../ts/data/subject/PostDataFactory";
import StateViewController from "../../vc/StateViewController";
import {assert} from "../../../ts/common/Assert";

const PostLocateMapPage = (props:IRouteProps) =>
{
    const postType:PostType = getManager().navigation.model.routeIDs.post_type ?? "organisation";
    const routeModel = getModelFactory().postListRoute.getDefaultModel(postType);

    const viewState = StateViewController({
        routeProps: props,
        assert: routeModel
    })

    if(viewState.overrideView){
        return viewState.overrideView;
    }
    assert(routeModel);

    const getCardContent = (locateChoice:LocatableDataChoice, fromLngLat:LngLat|null, index:number, tally:number):React.JSX.Element|null => {

        const choice = locateChoice as PostDataChoice

        const postRoute = choice ? (routeModel.choices[choice.id] ?? null) : null;
        if (!postRoute)
        {
            return null;
        }
        let distance = fromLngLat ? locateChoice.getReadableDistance(fromLngLat) : null;
        distance = distance ? distance : "Unknown distance"


        let address = choice.addressVO.town;
        if (choice.addressVO.county)
        {
            address = address ? address + ", " : "";
            address += choice.addressVO.county;
        }
        if (choice.addressVO.countryName)
        {
            address = address ? address + ", " : "";
            address += choice.addressVO.countryName;
        }

        return <>
            <div className="container">

                <div className="row">
                    <div className="col-12">
                        <h3>{choice.name}</h3>
                    </div>
                </div>
                <div className="row">
                    <div className="col-4">

                        <p className="smaller">
                            {index + 1} of {tally}
                        </p>
                    </div>
                    <div className="col-4">

                        <p className="smaller">
                            {fromLngLat ? <>{distance}<br /></> : <></>}
                        </p>
                    </div>
                    <div className="col-4">

                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <p>{address}</p>
                    </div>
                </div>
                <div className="row mt-2">
                    <div className="col-12 text-end">

                        <RouteChoiceButton
                            key={postRoute.realPath}
                            routeChoice={postRoute}
                            className="btn btn-primary smaller-on-small"
                        >
                            View
                        </RouteChoiceButton>
                    </div>
                </div>
            </div>

        </>
    }
    return <>
        <LocateMapPage
            getCardContent={getCardContent}
            {...props}
        />
    </>
}

export default PostLocateMapPage;